/**
 *  Example:
 *  <button type="button" class="site-header__toggle menu-toggle hamburger hamburger--slider"
 *     aria-label="Menu" role="button" aria-controls="navigation"
 *     data-target=".site-header__nav" data-menu-toggle>
 *    <span class="hamburger-box">
 *      <span class="hamburger-inner"></span>
 *    </span>
 *  </button>
 *
 *  Remember to add an id "navigation" to the target to match aria-controls:
 *    <div class="site-header__nav" id="navigation" …
 */

import $ from 'jquery';
import {$body} from '4.plugins/Globals/Globals';
require('magnific-popup');

export default class MenuToggle {
  constructor($context) {
    this.$items = $context.find('[data-menu-toggle]');

    if (this.$items.length) {
      this.init();
    }
  }

  init() {
    this.activeClass = this.$items.data('active-class') || 'is-active';
    this.bodyClass = this.$items.data('body-class') || 'is-menu-open';
    this.target = this.$items.data('target') || '.site-header__menu-wrapper';
    this.menuLink = this.$items.data('menu-link') || '.site-header__menu a';
    const $target = $(this.target);

    this.$items.click((e) => {
      e.preventDefault();
      this.$items.toggleClass(this.activeClass);
      const isOpen = this.$items.hasClass(this.activeClass);
      $body.toggleClass(this.bodyClass, isOpen);
      if (isOpen) {
        // $target.slideDown();
        this.open();
      }
      else {
        // $target.slideUp();
        this.close();
      }

    });

    $body.on('click.menu-toggle', this.menuLink, () => {
      this.$items.removeClass(this.activeClass);
      $body.removeClass(this.bodyClass);
      // $target.slideUp();
      this.close();
    });
  }

  open() {
    $.magnificPopup.open({
      items: {
          src: '.mobile-menu-popup'
      },
      type: 'inline',
      // For animation
      removalDelay: 300,
      fixedContentPos: true,
      mainClass: 'mfp-fade mfp-menu',
      callbacks: {
        close: () => {
          this.$items.removeClass(this.activeClass);
          $body.removeClass(this.bodyClass);
        }
      }
    });
  }

  close() {
    $.magnificPopup.close();
  }
}



// WEBPACK FOOTER //
// ./4.plugins/MenuToggle/MenuToggle.js